// extracted by mini-css-extract-plugin
export default {"main":"style_main__g3MAW","start":"style_start__f1rOD"};